import { createFileRoute } from "@tanstack/react-router";

import CardsCallback from "../components/CardsCallback";

export const Route = createFileRoute("/cards/callback")({
  component: CardsCallback,
  validateSearch: (search: Record<string, unknown>) => ({
    code: typeof search.code === "string" ? search.code : undefined,
    state: typeof search.state === "string" ? search.state : undefined,
    error: typeof search.error === "string" ? search.error : undefined,
  }),
});
